module.exports = __webpack_public_path__ + "img/hot_bg.63a282f3.png";